<template>
  <div>
    <div v-html="rendered_text" class="qcw-comment__content" v-if="!isPreviousMessageNotifier"></div>
    <div v-if="isPreviousMessageNotifier">
      <blockquote>
        <p v-html="prev_session_message"></p>
      </blockquote>
      <p><small v-html="prev_session_notice"></small></p>
    </div>
  </div>
</template>

<script>
import QiscusTextParser from '../lib/textparser';

export default {
  name: 'CommentRender',
  props: ['text'],
  data() {
    return {
      rendered_text: this.text,
      prev_session_message: '',
      prev_session_notice: '',
    };
  },
  computed: {
    isPreviousMessageNotifier() {
      const isTrue = this.text.includes('This message was sent on previous session by');
      if (isTrue) {
        const lines = this.text.split('\n').filter(l => l.trim() !== '');
        lines.forEach((line, index) => {
          if (index < lines.length - 2) {
            this.prev_session_message += `${line.trim()}<br>`;
          } else {
            this.prev_session_notice += `${line}<br>`;
          }
        });
      }
      return isTrue;
    },
  },
  created() {
    this.rendered_text = QiscusTextParser.parse(this.text);
    this.rendered_text = (typeof emojione !== 'undefined') ? emojione.toImage(this.rendered_text) : this.rendered_text;
  },
};
</script>




// WEBPACK FOOTER //
// src/components/CommentRender.vue